// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectors {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
    width: 100%;
}

.presets {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
}

.preset {
    font-size: 1.8rem;
    border: 2px solid var(--main-foreground-color);
    background: none;
    color: var(--main-foreground-color);
    border-radius: 999px;
    padding: 0.2rem 0.75rem;
    cursor: pointer;
    transition: background-color 0.1s, color 0.1s;
}

.preset.selected {
    background-color: var(--main-foreground-color);
    color: white;
}

.dose-stepper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 0.5rem;
}

.dose-stepper .stepper-btn {
    font-size: 2rem;
    width: 3rem;
    height: 3rem;
    border: none;
    background-color: transparent;
    border: 2px solid var(--main-foreground-color);
    color: var(--main-foreground-color);
    border-radius: 50%;
    cursor: pointer;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.dose-stepper .stepper-btn:disabled {
    opacity: 0.3;
    cursor: default;
}

.dose-stepper .stepper-value {
    font-size: 2.2rem;
    font-weight: bold;
    text-align: center;
    flex: 1 1;
    color: var(--secondary-color);
}

.dose-stepper .stepper-unit {
    font-size: 1.5rem;
    font-weight: normal;
    color: var(--light-grey-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/DoseSelector.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,8CAA8C;IAC9C,gBAAgB;IAChB,mCAAmC;IACnC,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,8CAA8C;IAC9C,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,SAAO;IACP,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".selectors {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0.5rem 0;\n    width: 100%;\n}\n\n.presets {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.preset {\n    font-size: 1.8rem;\n    border: 2px solid var(--main-foreground-color);\n    background: none;\n    color: var(--main-foreground-color);\n    border-radius: 999px;\n    padding: 0.2rem 0.75rem;\n    cursor: pointer;\n    transition: background-color 0.1s, color 0.1s;\n}\n\n.preset.selected {\n    background-color: var(--main-foreground-color);\n    color: white;\n}\n\n.dose-stepper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: 0.5rem;\n}\n\n.dose-stepper .stepper-btn {\n    font-size: 2rem;\n    width: 3rem;\n    height: 3rem;\n    border: none;\n    background-color: transparent;\n    border: 2px solid var(--main-foreground-color);\n    color: var(--main-foreground-color);\n    border-radius: 50%;\n    cursor: pointer;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.dose-stepper .stepper-btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n\n.dose-stepper .stepper-value {\n    font-size: 2.2rem;\n    font-weight: bold;\n    text-align: center;\n    flex: 1;\n    color: var(--secondary-color);\n}\n\n.dose-stepper .stepper-unit {\n    font-size: 1.5rem;\n    font-weight: normal;\n    color: var(--light-grey-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
